export const APP_STORE_URL = 'https://apps.apple.com/no/app/aprendos-learn-languages/id6761994450';
const APP_STORE_BADGE_SRC = 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';

export default function AppStoreBadge({
  className = '',
  size = 'default',
}) {
  const widthClass = size === 'small' ? 'w-[132px]' : 'w-[156px] sm:w-[168px]';

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download on the App Store"
      className={`inline-flex ${widthClass} transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D63AB4] focus-visible:ring-offset-2 ${className}`}
    >
      <img
        src={APP_STORE_BADGE_SRC}
        alt="Download on the App Store"
        width="156"
        height="52"
        className="h-auto w-full"
        loading="lazy"
      />
    </a>
  );
}
